<template>
	<div>
		<div class="title">{{appInfo.type == 1 ? '虚拟' : ''}}支付能力</div>
		<div class="pay-detail" v-if="operation === 0 || operation === 2 || operation === 5 || operation === 3">
			<div class="content">
				<div><i class="open-icon"></i></div>
				<div class="des">
					<div class="text">{{appInfo.type == 1 ? '虚拟' : ''}}支付功能已开通</div>
					<div class="time">开通时间：{{timeFormat(ctime)}}</div>
				</div>
			</div>
		</div>
		<div class="pay-detail" v-if="operation === 1 || operation === 4">
			<div class="content fail">
				<div><i class="open-icon close-icon"></i></div>
				<div class="des">
					<div class="text close">{{appInfo.type == 1 ? '虚拟' : ''}}支付功能已关闭</div>
					<div class="time">关闭时间：{{timeFormat(ctime)}}</div>
					<div class="reason">关闭原因：{{remark}}</div>
				</div>
			</div>
		</div>
		<div class="pay-detail" v-if="operation === null">
			<div class="why-how">
				<div class="why">
					<div class="text">小程序不具备{{appInfo.type == 1 ? '虚拟' : ''}}支付能力</div>
					<div class="can">若要开通请与相关运营人员联系</div>
				</div>
				<div class="how">
            		<div class="process-step">
            			<div class="process">
            				<div class="text">接入</div>
            				<div class="text bottom">流程</div>
            			</div>
            			<div class="caret"></div>
                		<div class="step">
                			<span class="step-1"></span>
                    		<span class="text">提交申请资料</span>
                    		<span class="arrow"></span>
               			</div>
				        <div class="step">
				            <span class="step-2"></span>
				    		<span class="text">技术开发</span>
				    		<a @click="goToFile">查看开发文档</a>
				    		<span class="arrow"></span>
				        </div>
				        <div class="step">
				            <span class="step-3"></span>
				            <span class="text" v-if="appInfo.type == 1">上线内购项目</span>
				            <span class="text" v-else>售卖商品</span>
				        </div>
            		</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import dao from '@/lib/dao.js';
export default {
	props: {
        appInfo: {
            type: Object,
            default() {
                return {};
            }
        }
    },
	data() {
		return {
			operation: '',
			ctime: '',
			remark: ''
		}
	},
	methods: {
		checkPayStatus() {
			dao.shop.getPaymentInfo({
				appId: this.$route.params.appId
			})
			.then(data => {
				if (data) {
					this.operation = data.operation;
	               	this.ctime = data.ctime;
	               	this.remark = data.remark;
	            } else {
	            	this.operation = null;
	               	this.ctime = '';
	               	this.remark = '';
	            }
            }).catch(msg => {
                this.$message.error(msg);
            });
		},
		timeFormat(str) {
            let date = new Date(str);
            return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        },
        goToFile() {
        	this.appInfo.type == 1 ? window.open('http://miniapp.bilibili.com/small-game-doc/open/recharge/Recharge.html') : window.open('http://miniapp.bilibili.com/small-app-doc/open/pay/pay-params/');
        }
	},
	mounted() {
		this.checkPayStatus();
	}
}
</script>
<style lang="less" scoped>
.title {
	margin: 0 0 17px 0;
    color: #5C667E;
    font-size: 16px;
    padding: 0;
}
.pay-detail {
	padding: 20px;
	background: #fff;
	border: 1px solid #E0E5EC;
	min-height: 263px;
	font-size: 0;
	.content {
		width: 930px;
		background: rgba(67,206,91,0.10);
		padding: 20px;
		display: flex;
		color: #5C667E;
		text-align: left;

		&.fail {
			background: rgba(255,123,88,0.10);
		}

		.open-icon {
			width: 30px;
	        height: 30px;
	        display: inline-block;
	        background: url(./../../assets/icon-done@2x.png) center center no-repeat;
	        background-size: 100% 100%;
	        vertical-align: bottom;

	        &.close-icon {
	        	width: 30px;
	        	height: 30px;
	        	display: inline-block;
	        	background: url(./../../assets/icon_failed.png) center center no-repeat;
	        	background-size: 100% 100%;
	        	vertical-align: bottom;
	        }
		}
		.des {
			margin-left: 10px;
			.text {
				margin-bottom: 3px;
				font-size: 16px;
				font-weight: 500;
			}
			.time {
				font-size: 12px;
				color: #5C667E;
				margin-bottom: 3px;
			}
			.reason {
				font-size: 12px;
				color: #FF7B58;
			}
		}
	}
	.why {
		margin-bottom: 30px;
		margin-top: 10px;
    	padding-top: 170px;
	    text-align: center;
	    font-size: 14px;
	    color: #5C667E;
	    background: url(./../../assets/nonactivated.png) center 0 no-repeat;
	    background-size: 168px 153px;

		.text {
			font-size: 16px;
			font-weight: 500;
			color: #5C667E;
			margin-bottom: 7px;
		}
		.can {
			font-size: 14px;
			color: #99A2AA;
		}
	}
	.how {
		width: 650px;
		margin-left: 185px;
		border: 1px solid #E0E5EC;
		margin-bottom: 40px;

		.process-step {
        	display: flex;
        	height: 64px;
       		
       		.process {
       			width: 52px;
       			background: #F7F8FB;
       			color: #9AA7C1;

       			.text {
       				padding: 11px 5px 0 11px;
       				font-size: 14px;
					letter-spacing: 2px;

					&.bottom {
						padding-top: 0;
					}
			    }
       		}
       		.caret {
       			width: 0;
				height: 0;
				border-top: 3px solid transparent;
				border-bottom: 6px solid transparent;
				border-left: 6px solid #F7F8FB;
				position: relative;
				top: 26px;
				margin-right: 10px;
       		}
	        .step {
	        	display: flex;
	        	.step-1 {
	        		width: 45px;
				    height: 40px;
				    display: inline-block;
				    background: url(./../../assets/01@2x.png) center center no-repeat;
				    background-size: 100% 100%;
				    margin: 13px 10px;
	            }
	            .step-2 {
	            	width: 45px;
				    height: 40px;
				    display: inline-block;
				    background: url(./../../assets/02@2x.png) center center no-repeat;
				    background-size: 100% 100%;
				    margin: 13px 10px;
	            }
	             .step-3 {
	            	width: 45px;
				    height: 40px;
				    display: inline-block;
				    background: url(./../../assets/03@2x.png) center center no-repeat;
				    background-size: 100% 100%;
				    margin: 13px 10px;
	            }
				.text {
					font-size: 12px;
					color: #5C667E;
					height: 40px;
					padding-top: 25px;
				}
				& a {
					width: 72px;
					margin-top: 25px;
					margin-left: 5px;
					font-size: 12px;
					color: #789AFF;
					text-decoration: underline;
					vertical-align: bottom;
					cursor: pointer;
				}
	           .arrow {
	           		width: 10px;
				    height: 18px;
				    display: inline-block;
				    background: url(./../../assets/arrow@2x.png) center center no-repeat;
				    background-size: 100% 100%;
				    margin: 25px 20px;
	           }  
	        } 
    	}
	}
}
</style>


// WEBPACK FOOTER //
// src/page/manage/Payment.vue